import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';

const heltAr = 'c1-fulltid';
const host = 'c2-deltid';

const cValg: RadioButtonValgModel<VeilederVgsUrDto>[] = [
    { id: 'c1', value: heltAr, tekst: 'valgFulltid' },
    { id: 'c2', value: host, tekst: 'valgDeltid' },
];

export default {
    c1_fulltid: heltAr,
    c2_deltid: host,
    cValg,
};
